module.exports = __webpack_public_path__ + "static/media/strat.98b3782a.svg";